import styled from 'styled-components';

const FlightDelayWrapper = styled.div`



.p-inputtext {
    border: 1px solid #6B47F5;
    background-color: #fff;
    border-radius: 5px;
    width: 100%;
    text-align: start;
    font-size: 16px;
    font-weight: 700;
    color: #494948;
    height: 50px;
}
.p-button.p-component {
    border-radius: 5px;
    // width: 100%;
    font-weight: 700;
    font-size: 16px;
    text-transform: uppercase;
}
.p-button-warning {
    background: #6B47F5 !important;
    color: #FFFFFF !important;
}
.p-button-info {
    border: 1px solid #6B47F5 !important;
    color: #6B47F5 !important;
}

.custom-calendar-input{
    input{
        border-right:none;
    }
    .p-button-icon-only{
        padding:0;
        background:transparent;
        color:rgb(110, 159, 187);
        border-left:none;
        border-radius:0;
        border-color:#6B47F5;
        :focus{
            box-shadow:none;
        }
    }

    &.p-invalid{
        .p-button-icon-only{
            border-color:red;
            color:red; 
        }
    }
}

.ar{
    .custom-calendar-input .p-button-icon-only {
        border-left: 1px solid #6B47F5;
        border-right: none;
        border-radius: 0;
        // border-color: #ced4da;
    }
    .custom-calendar-input input {
        border-right: 1px solid #ced4da;
        border-left: none;
    }
    .prefix {
        border: 1px solid #ced4da;
        border-left: none;
    }
}


`;


export default FlightDelayWrapper;